import { render, staticRenderFns } from "./ListCardGroups.vue?vue&type=template&id=ffb6d7b2&scoped=true"
import script from "./ListCardGroups.vue?vue&type=script&lang=js"
export * from "./ListCardGroups.vue?vue&type=script&lang=js"
import style0 from "./ListCardGroups.vue?vue&type=style&index=0&id=ffb6d7b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb6d7b2",
  null
  
)

export default component.exports